import MyExperienc from "../MyExperienc";
import AboutMe from "../AboutMe";
import ContactMe from "../ContactMe";
import Footer from "../Footer";
import HeroSection from "../HeroSection";
import MyPortfolio from "../MyPortfolio";
import MySkills from "../MySkills";
import Testimonial from "../Testimonials";
import Chatbot from "../Chatbot";

export default function Home() {
  return (
    <>
      <Chatbot />
      <HeroSection />
      <MySkills />
      <MyExperienc/>
      <AboutMe />
      <MyPortfolio />
      <Testimonial />
      <ContactMe />
      <Footer />
    </>
  );
}
